import { dataCheckSquareSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCheckSquareSolid = /*#__PURE__*/createIcon(dataCheckSquareSolid)
export default IconCheckSquareSolid
